import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { REPORT_TIME_ZONES } from '../../timeZones';

const TimeZoneDropdown = ({ paramTimeZone, setParamTimeZone, isDisabled = false }) => {
    return (
        <FormControl fullWidth variant="outlined" disabled={isDisabled}>
            <InputLabel id="timezone-label">Time Zone</InputLabel>
            <Select
                labelId="timezone-label"
                id="timezone-select"
                value={paramTimeZone}
                onChange={(e) => setParamTimeZone(e.target.value)}
                label="Time Zone"
            >
                {REPORT_TIME_ZONES.map((x) => (
                    <MenuItem key={x.code} value={x.code}>
                        {x.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default TimeZoneDropdown;
